import { render, staticRenderFns } from "./addShare.vue?vue&type=template&id=35a57b84&scoped=true"
import script from "./addShare.vue?vue&type=script&lang=js"
export * from "./addShare.vue?vue&type=script&lang=js"
import style0 from "./addShare.vue?vue&type=style&index=0&id=35a57b84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a57b84",
  null
  
)

export default component.exports